// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1kv62","rootMobile":"styles_rootMobile__YoP3O"};